export default __webpack_public_path__ + "images/3E.5430a3a.png";